import { Box } from '@mui/material';
import { MouseEvent, PropsWithChildren } from 'react';

const LINK_SX = {
  color: 'primary.main',
  textDecoration: 'underline',
  textUnderlineOffset: 2,
  '&:hover': {
    opacity: 0.8,
  },
} as const;

type InterruptionMessageLinkProps = PropsWithChildren<{
  href: string;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}>;

const InterruptionMessageLink = ({ children, href, onClick }: InterruptionMessageLinkProps) => (
  <Box component="a" href={href} sx={LINK_SX} onClick={onClick}>
    {children}
  </Box>
);

export default InterruptionMessageLink;
